var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.588,
    height: 32.588,
    viewBox: "0 0 32.588 32.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11715",
    "data-name": "Path 11715",
    d: "M16.294,0A16.294,16.294,0,1,0,32.588,16.294,16.293,16.293,0,0,0,16.294,0Zm7.129,17.312H12.642l4.2,4.2a1.018,1.018,0,1,1-1.44,1.44L9.638,17.188a1,1,0,0,1-.264-.894,1,1,0,0,1,.265-.9L15.4,9.638a1.018,1.018,0,0,1,1.44,1.44l-4.2,4.2h10.78a1.018,1.018,0,1,1,0,2.037Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtnIcon);
export default __webpack_public_path__ + "static/media/BackBtn_Icon.8a31605e20855c3fc50b911386b65c90.svg";
export { ForwardRef as ReactComponent };